import { render, staticRenderFns } from "./logoPreviewModal.vue?vue&type=template&id=edda986e&scoped=true&"
import script from "./logoPreviewModal.vue?vue&type=script&lang=ts&"
export * from "./logoPreviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./logoPreviewModal.vue?vue&type=style&index=0&id=edda986e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edda986e",
  null
  
)

export default component.exports